import { render } from "./CartList.vue?vue&type=template&id=0edd3232&scoped=true&bindings={\"cartListWithProducts\":\"setup\"}"
import script from "./CartList.vue?vue&type=script&lang=js"
export * from "./CartList.vue?vue&type=script&lang=js"

import "./CartList.vue?vue&type=style&index=0&id=0edd3232&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0edd3232"

export default script